/** @jsx h */

import { h } from 'preact';
import { PropTypes } from 'preact-compat';
import { langPack } from '../../utils/langPack';
import style from './style.scss';

export const API_NOTIFICATION_TYPE = {
  SUCCESS: 'success',
  DANGER: 'danger',
  INFO: 'info',
  DEFAULT: 'default',
  WARNING: 'warning',
};

const APINotifications = ({
  reloadRequired, type, iconClassName, message, locale,
}) => (
  <div className={style[`notification-custom-${type}`]}>
    <div className={style['notification-custom-icon-wrap']}>
      <i className={`${style['notification-custom-icon']} ${iconClassName}`} />
    </div>
    <div className={style['notification-custom-content']}>
      {reloadRequired ? (
        [
          <p className={`${style['notification-custom-message']} notification-message`}>
            {langPack[locale].API.NOTIFICATION_MESSAGE}
          </p>,
          <p className={`${style['notification-custom-message-small']} notification-message`}>
            {message}
          </p>,
        ]
      ) : (
        <p className={`${style['notification-custom-message']} notification-message`}>{message}</p>
      )}
    </div>
  </div>
);

APINotifications.propTypes = {
  reloadRequired: PropTypes.bool.isRequired,
  iconClassName: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(API_NOTIFICATION_TYPE)).isRequired,
};

export default APINotifications;



// WEBPACK FOOTER //
// ./components/api-notifications/index.js